import { v4 as uuidv4 } from "uuid";

const uniqueId = () => uuidv4().replace(/-/g, "");

export default uniqueId;
